
export const company = {
    namespaced: true,
    state: {
        companyData:null,
    },
    actions: {
        saveCompanyAction({ commit }, company) {
            commit('storeCompany', company);
        },
        clearCompanyAction({ commit }) {
            commit('clearCompany');
        },
    },
    mutations: {
        storeCompany(state, company) {
            state.companyData = company;
        },
        clearCompany(state) {
            state.companyData = null;
        },
    },
    getters: {
        // Define the getter for companyData
        companyData(state) {
            return state.companyData;
        },
    },
};
